export const environment = {
  production: true,
  logrocketAppID: 'a0f9xx/evold',
  testStripeKey:
    'pk_test_51Jyc65D7DXV9TT5hYp0Vfi9XFxYhfZoStr0mofpX9Ru2fj2vii6ZGoI2qSgguCbYUABHO4g3YLwDf3ocmD0phnwl00OruQzZYE',
  liveStripeKey:
    'pk_live_51Jyc65D7DXV9TT5hoNf6L0BBlvIdyaizdMOCngr4Fqc8tCST7TgAsZ5k9bKGpbHHzurVBDqsKKz83GPLxEREwhsE00h6wnccCc',
  backendUrl: 'https://asylumtix-canary.hasura.app/v1/graphql',
  wss: 'https://asylumtix-canary.hasura.app/v1/graphql',

  customApiUrl: 'https://asylumtix-be-canary-d7d79c8c6697.herokuapp.com',

  releaseApiUrl: 'https://admin.asylumtix.com',
  disableDynamicReleaseRedirect: false,
  disableLoggingOverride: false,

  firebaseConfig: {
    apiKey: 'AIzaSyA2ooB72MnsUZcWPyvKT5fQaoJZ5vJ7gCI',
    authDomain: 'tickets-8ff85.firebaseapp.com',
    projectId: 'tickets-8ff85',
    storageBucket: 'tickets-8ff85.appspot.com',
    messagingSenderId: '997702436797',
    appId: '1:997702436797:web:3f5350646b8b2e52fd74d4',
    measurementId: 'G-DR8V8ME4VB'
  }
};
